import React from "react";
import { Checkbox, Form, Input } from "antd";

const { TextArea } = Input;

function Challenges({ dataMechType }) {
  return (
    <>
      <div className="custom-title !text-[#111928] rounded-[.5rem]">
        Challenges & Opportunities
      </div>
      <Form.Item
        name="mechanizationTypeIds"
        label={"Type of Mechanization And Technology"}
      >
        <Checkbox.Group
          options={
            dataMechType?.map((item) => ({
              value: item?.mechId,
              label: item?.mechName,
            })) ?? []
          }
        />
      </Form.Item>
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
        <Form.Item
          name="mechanizationNarrative"
          label={"Explain mechanization"}
        >
          <TextArea rows={3} placeholder="Narrative" className="text_area" />
        </Form.Item>
        <Form.Item name="farmerTrainings" label={"Farmers Trainings"}>
          <TextArea
            rows={3}
            placeholder="Narrative - training gaps"
            className="text_area"
          />
        </Form.Item>
    
      <Form.Item
        name="irrigationEfficiency"
        label={"Efficiency of the Irrigation System"}
      >
        <TextArea
          rows={3}
          placeholder="Conveyance efficiency,Distribution efficiency,Application efficiency"
          className="text_area"
        />
      </Form.Item>
    
        <Form.Item
          name="improvedSeedVarieties"
          label={"Improved Seed Varieties"}
        >
          <TextArea rows={3} className="text_area" />
        </Form.Item>
        </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
        <Form.Item name="invasiveSpecies" label={"Invasive Species"}>
          <TextArea rows={3} className="text_area" />
        </Form.Item>
        <Form.Item
          name="climateChangeIssues"
          label={"Climate Change Issues"}
        >
          <TextArea rows={3} className="text_area" />
        </Form.Item>
      </div>
    </>
  );
}

export default Challenges;
